import { CURRENT_USER_SET } from "./actionTypes";
import { AuthenticatedUser } from "../../models/AuthenticatedUser";

export const setCurrentUserAction = (user: AuthenticatedUser) => {
    return {
        type: CURRENT_USER_SET,
        payload: user        
    };
};
